/**
 * home-sections.js — Phase 5A.1 newsletter form feedback.
 *
 * Intercepts the newsletter form submit, posts to Shopify's /contact endpoint
 * (form_type=customer), and shows inline success/error feedback without a
 * full page reload. Falls back to default form submit if fetch fails.
 */

const FORM_SELECTOR = 'form[data-newsletter-form]';
const FEEDBACK_SELECTOR = '[data-newsletter-feedback]';
const SUBMIT_SELECTOR = '[data-newsletter-submit]';

function setFeedback(form, state, message) {
  const fb = form.querySelector(FEEDBACK_SELECTOR);
  if (!fb) return;
  fb.dataset.state = state;
  fb.textContent = message;
}

function setSubmitting(form, isSubmitting) {
  const btn = form.querySelector(SUBMIT_SELECTOR);
  if (!btn) return;
  btn.disabled = isSubmitting;
  const original = btn.dataset.labelDefault;
  const submitting = btn.dataset.labelSubmitting;
  if (isSubmitting && submitting) btn.textContent = submitting;
  else if (!isSubmitting && original) btn.textContent = original;
}

async function handleSubmit(form, e) {
  e.preventDefault();
  setSubmitting(form, true);
  setFeedback(form, 'pending', '');

  const data = new FormData(form);
  try {
    const res = await fetch(form.action, {
      method: 'POST',
      body: data,
      headers: { 'Accept': 'application/json, text/html' }
    });
    if (res.ok || res.status === 302) {
      setFeedback(form, 'success', form.dataset.labelSuccess || '');
      form.reset();
    } else {
      setFeedback(form, 'error', form.dataset.labelError || '');
    }
  } catch (err) {
    setFeedback(form, 'error', form.dataset.labelError || '');
  } finally {
    setSubmitting(form, false);
  }
}

function boot() {
  document.querySelectorAll(FORM_SELECTOR).forEach((form) => {
    form.addEventListener('submit', (e) => handleSubmit(form, e));
    const btn = form.querySelector(SUBMIT_SELECTOR);
    if (btn && !btn.dataset.labelDefault) {
      btn.dataset.labelDefault = btn.textContent.trim();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
